import { __decorate, __extends } from "tslib"; // @ts-ignore

import { VSelect } from 'vuetify/lib/components';
import { Component, Prop, Vue } from 'vue-property-decorator';

var VSelectOutlined =
/** @class */
function (_super) {
  __extends(VSelectOutlined, _super);

  function VSelectOutlined() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop({
    default: true,
    type: Boolean
  })], VSelectOutlined.prototype, "outlined", void 0);

  __decorate([Prop({
    default: 'white'
  })], VSelectOutlined.prototype, "backgroundColor", void 0);

  VSelectOutlined = __decorate([Component({
    name: 'VSelectOutlined',
    extends: VSelect
  })], VSelectOutlined);
  return VSelectOutlined;
}(Vue);

export default VSelectOutlined;
;